import moment from 'moment';
import React, { useState, useEffect } from 'react';
import ReactHtmlParser from 'html-react-parser';
import LcIcon from '../../../../Generic/LcIcon';
import LcIconLink from '../../../../Generic/LcIconLink';
import LcTooltip from '../../../../Generic/LcTooltip';
import "./index.css";
import TextTools from "../../../../../services/TextTools/TextTools"

interface Props {
    element: any
    // mostrarMais: any
    getSelectionRow: Function
}

const Comment: React.FC<Props> = (props) => {
    const [commentText, setCommentText] = useState<string>("");
    const [comentDate, setCommentDate] = useState<string>("");
    const [commentDateTooltip, setCommentDateTooltip] = useState<string>("");
    const [showComment, setShowComment] = useState<boolean>(false);
    const textTools = new TextTools();

    const showButton = (text: string) => {
        let show = false;
        let textParse = ReactHtmlParser(text);
        let textParseItens = (textParse instanceof Array) ? [].slice.call(textParse) : [textParse];

        let pList = textParseItens.filter((element: any) => element.type && element.type == 'p');
        let brList = textParseItens.filter((element: any) => element.type && element.type == 'br');
        let spanList = textParseItens.filter((element: any) => element.type && element.type == 'span');
        let imgList = textParseItens.filter((element: any) => element.type && element.type == 'img');
        let tableList = textParseItens.filter((element: any) => element.type && element.type == 'table');
        let nList = textParseItens.filter((element: any) => element == '\n');

        const list: any[] = [...pList, ...nList, ...brList, ...spanList];

        if (tableList.length >= 1 || imgList.length >= 1 || list.length > 3 || commentText.length >= 170) {
            show = true
        }

        return show;
    }

    useEffect(() => {
        if (props.element) {
            setCommentText(textTools.cleanTagEmailParse(props.element.text));
            setCommentDate(moment(props.element.commentDate).fromNow());
            setCommentDateTooltip(moment(props.element.commentDate).format('DD/MM/YYYY, HH:MM'))
        }
    }, [props.element]);

    return (
        <div key={props.element.id} className="cardComments">
            <div className="hearderComment">

                {
                    props.element.image
                        ? <img className="avatar" alt="" src={props.element.image && `data:image/jpeg;base64,${props.element.image}`} />
                        : <LcIcon icon="ppi ppi-user" />
                }
                <div className="infos">
                    <div className="commmentsInfo" >
                        <h4>{props.element.nameUser}</h4>
                        <p>{comentDate}</p>
                    </div>
                    <div className="iconsActions">
                        {
                            showButton(commentText) &&
                            <LcIconLink
                                size={'small'}
                                icon={(!showComment) ? `ppi ppi-chevron-down` : 'ppi ppi-chevron-up'}
                                tooltip={(!showComment) ? "Mostrar mais" : "Mostrar menos"}
                                onClick={() => setShowComment(!showComment)}
                            />
                        }
                        <LcIconLink
                            size={'small'}
                            icon={`ppi ppi-external-link`}
                            tooltipPosition={'moreLeft'}
                            tooltip={
                                props.element &&
                                <span><strong>{props.element.idSolicitation}</strong>: {props.element.subjectWork} </span>
                            }
                            onClick={() => props.getSelectionRow(props.element.idSolicitation)}
                        />
                        <LcTooltip
                            trigger={"hover"}
                            position={'left'}
                            content={
                                <div style={{
                                    width: '300px',
                                    flexDirection: "column",
                                    flexWrap: "wrap",
                                    alignContent: "center",
                                    alignItems: "flex-start",
                                    fontFamily: 'Inter',
                                    fontStyle: 'normal'
                                }}>
                                    <h3 style={{ fontFamily: 'Inter' }}>{props.element.new ? 'Novo comentário' : "Comentário"}</h3>
                                    <div style={{
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        margin: '5px 0px',
                                        alignItems: "center"
                                    }}>
                                        <label style={{ color: '2B304F' }} htmlFor="data">Data</label>
                                        <p style={{ color: "#2B304F", fontSize: "14px", marginRight: '20px' }}><b>{commentDateTooltip}</b></p>
                                    </div>

                                    <div style={{
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        margin: '5px 0px',
                                        alignItems: "center"
                                    }}>
                                        <label style={{ color: '2B304F' }} htmlFor="data">Equipe Atual </label>
                                        <p style={{ color: "#2B304F", fontSize: "14px", marginRight: '20px', maxWidth: '150px' }}><b>{props.element.teamWork}</b></p>
                                    </div>
                                    <div style={{
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        margin: '5px 0px',
                                        alignItems: "center"
                                    }}>
                                        <label style={{ color: '2B304F' }} htmlFor="data">Último trabalho</label>
                                        <p style={{ color: "#2B304F", fontSize: "14px", marginRight: '20px' }}> <b>{props.element.workId}</b></p>
                                    </div>
                                </div>
                            }
                            maxWidth={"500px"}
                            children={<LcIcon icon={"ppi ppi-information-circle"} size={'small'} color={props.element.new ? '#F29100' : ''} />}
                        />
                    </div>
                </div>
            </div>
            <div className="bodyComment">
                <p style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    lineHeight: '16px',
                    maxHeight: (!showComment) ? '50px' : '',
                    WebkitLineClamp: (!showComment) ? 3 : '',
                    WebkitBoxOrient: 'vertical',
                    fontFamily: "Inter !important",
                    wordBreak: 'break-word'
                }}>
                    {ReactHtmlParser(commentText)}
                </p>
            </div>
        </div>
    )
};

export default Comment;